import { render, staticRenderFns } from "./ConfiguradorNiveis.vue?vue&type=template&id=638e3656&scoped=true"
import script from "./ConfiguradorNiveis.vue?vue&type=script&lang=js"
export * from "./ConfiguradorNiveis.vue?vue&type=script&lang=js"
import style0 from "./ConfiguradorNiveis.vue?vue&type=style&index=0&id=638e3656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e3656",
  null
  
)

export default component.exports